import React from 'react';
import { FiInfo, FiCheckCircle, FiAlertTriangle, FiXCircle, FiX } from 'react-icons/fi';

const Alert = ({
  children,
  title,
  variant = 'info',
  onClose,
  className = '',
  ...props
}) => {
  const variants = {
    info: {
      bg: 'bg-brand-500/10 border-brand-500/20',
      icon: 'text-brand-500',
      title: 'text-brand-500',
      Icon: FiInfo,
    },
    success: {
      bg: 'bg-success/10 border-success/20',
      icon: 'text-success',
      title: 'text-success',
      Icon: FiCheckCircle,
    },
    warning: {
      bg: 'bg-warning/10 border-warning/20',
      icon: 'text-warning',
      title: 'text-warning',
      Icon: FiAlertTriangle,
    },
    danger: {
      bg: 'bg-danger/10 border-danger/20',
      icon: 'text-danger',
      title: 'text-danger',
      Icon: FiXCircle,
    },
  };

  const { bg, icon, title: titleColor, Icon } = variants[variant] || variants.info;

  return (
    <div
      className={`
        flex items-start gap-3 rounded-lg border p-4
        ${bg}
        ${className}
      `}
      role="alert"
      {...props}
    >
      <Icon size={20} className={`flex-shrink-0 mt-0.5 ${icon}`} />
      <div className="flex-1">
        {title && (
          <h5 className={`font-medium mb-1 ${titleColor}`}>{title}</h5>
        )}
        <div className="text-sm text-body dark:text-bodydark">
          {children}
        </div>
      </div>
      {onClose && (
        <button
          onClick={onClose}
          className="flex-shrink-0 text-body hover:text-black dark:text-bodydark dark:hover:text-white transition-colors"
          aria-label="Close"
        >
          <FiX size={18} />
        </button>
      )}
    </div>
  );
};

export default Alert;
